import { useState } from "react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { api, formatApiError } from "@/lib/api";

export const JoinList = ({ categories }) => {
  const [f, setF] = useState({ name: "", email: "", category: "", company: "", newsletter_optin: true });
  const [done, setDone] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.type === "checkbox" ? e.target.checked : e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    if (!f.category) return toast.error("Choose your participation category");
    try { await api.post("/events/interest", f); setDone(true); } catch (err) { toast.error(formatApiError(err)); }
  };
  return (
    <section className="max-w-7xl mx-auto px-5 py-20 grid lg:grid-cols-12 gap-10" data-testid="events-join-list">
      <div className="lg:col-span-5">
        <p className="overline text-[#E5332A]">Not ready to book?</p>
        <h2 className="font-display text-3xl font-bold mt-3 leading-tight">Join the Origin Cup list</h2>
        <p className="text-sm text-[#575757] mt-4">Get each month's origin, programme and seat count about two weeks before the session, plus first access to Africa Coffee Festival London.</p>
      </div>
      {done ? <p className="lg:col-span-7 font-display text-2xl font-bold self-center" data-testid="join-list-done">You're on the list. Look out for the next session email.</p> : (
        <form onSubmit={submit} className="lg:col-span-7 grid sm:grid-cols-2 gap-4" data-testid="join-list-form">
          <Input data-testid="join-list-name" required placeholder="Full name" value={f.name} onChange={set("name")} className="rounded-none" />
          <Input data-testid="join-list-email" required type="email" placeholder="Email" value={f.email} onChange={set("email")} className="rounded-none" />
          <select data-testid="join-list-category" value={f.category} onChange={set("category")} className="border border-input bg-white h-10 px-3 text-sm">
            <option value="">Participation category</option>
            {categories.map((c) => <option key={c} value={c}>{c}</option>)}
          </select>
          <Input data-testid="join-list-company" placeholder="Organisation (optional)" value={f.company} onChange={set("company")} className="rounded-none" />
          <label className="flex items-start gap-3 text-sm sm:col-span-2">
            <input type="checkbox" checked={f.newsletter_optin} onChange={set("newsletter_optin")} className="mt-1 accent-[#E5332A]" data-testid="join-list-newsletter" />
            <span>Also send me The Tuesday Roast every week.</span>
          </label>
          <button data-testid="join-list-submit" className="sm:col-span-2 sm:w-48 bg-[#0A0A0A] hover:bg-[#E5332A] text-white h-11 text-sm font-semibold transition-colors">Join the list</button>
        </form>
      )}
    </section>
  );
};

export const Organisers = () => (
  <section className="border-t border-[#E7E7E7]" data-testid="events-organisers">
    <div className="max-w-7xl mx-auto px-5 py-12 grid sm:grid-cols-4 gap-6 text-sm">
      <div><p className="overline text-[#575757]">Owned by</p><p className="font-bold mt-1">Africa One Group</p></div>
      <div><p className="overline text-[#575757]">In partnership with</p><p className="font-bold mt-1">Africa Global Agribusiness Partners</p></div>
      <div><p className="overline text-[#575757]">Marketed & coordinated by</p><p className="font-bold mt-1">Africa Brew Brief</p></div>
      <div><p className="overline text-[#575757]">Contact</p><a href="mailto:admin@africabrewbrief.com" data-testid="events-contact-email" className="font-bold mt-1 block text-[#E5332A] hover:underline">admin@africabrewbrief.com</a></div>
    </div>
  </section>
);
